module.exports = __webpack_public_path__ + "img/pex_33.facbe90e.png";